import React, { useEffect, useState } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

const copy = {
  pt: {
    hero: {
      title: "Serviços de Transição Digital",
      body:
        "A Invisible Cloud é entidade acreditada no Catálogo de Serviços de Transição Digital. Construímos soluções cloud e experiências digitais completas para acelerar a modernização do seu negócio.",
      button: "Quero candidatar-me",
    },

    overviewHighlights: [
      {
        title: "Apoio até 2.000€",
        description:
          "Financiamento até 2.000€ para adquirir serviços que digitalizam e aumentam a competitividade da sua empresa.",
      },
      {
        title: "100% a fundo perdido",
        description:
          "Os serviços são financiados a 100%, cobrindo integralmente as despesas elegíveis, sem qualquer custo para a sua empresa.",
      },
      {
        title: "Crescimento no mercado digital",
        description:
          "Garante a sua presença online com serviços que ajudam a impulsionar a visibilidade da sua marca e a atrair mais clientes.",
      },
      {
        title: "Fornecedores acreditados",
        description:
          "Trabalhe com empresas acreditadas, como a Invisible Cloud, para garantir que recebe as melhores soluções digitais.",
      },
    ],
    overview: {
      title: "O que é o Catálogo de Serviços de Transição Digital?",
      description:
        "O Catálogo de Serviços de Transição Digital é uma iniciativa do PRR (Plano de Recuperação e Resiliência) que oferece às empresas (PME) e empresários em nome individual (ENI) a oportunidade de acederem a serviços especializados para acelerar a sua transformação digital. Este catálogo reúne fornecedores acreditados, como a Invisible Cloud, que disponibilizam soluções para digitalizar o seu negócio e melhorar a sua presença online. Com apoios a fundo perdido até 2.000€, pode escolher entre diferentes serviços, desde a criação de uma loja online até ferramentas de marketing digital e gestão de clientes. O objetivo é garantir que as PME possam competir no mercado digital de forma mais eficiente, com o apoio técnico e financeiro necessário.",
    },
    eligibility: {
      title: "A sua empresa é elegível?",
      intro:
        "Se tem uma pequena ou média empresa (PME) ou é empresário em nome individual (ENI) e procura apoio para criar ou melhorar a sua estratégia e presença digital, os Serviços de Transição Digital podem ser a solução ideal. Este programa oferece apoios a fundo perdido até 2.000€, permitindo-lhe digitalizar o seu negócio sem qualquer custo adicional.",
      highlights: [
        {
          title: "PME ou Empresário em Nome Individual",
          description: "Micro, pequenas e médias empresas com atividade em Portugal.",
        },
        {
          title: "Setores elegíveis",
          description: "CAE principal abrangido pelo programa e operações regulares no território nacional.",
        },
        {
          title: "Regularização fiscal",
          description:
            "Situação fiscal e contributiva comprovada junto da Autoridade Tributária e Segurança Social.",
        },
      ],
    },
    steps: {
      title: "Como se pode candidatar?",

      items: [
        {
          title: "1 · Entre em contacto com a associação comercial e empresarial da sua região",
          description:
            "As associações comerciais locais são o ponto de partida. Estas orientam o processo de candidatura e garantem que está a concorrer às aceleradoras de comércio digital corretas.",
        },
        {
          title: "2 · Inicie o processo de candidatura junto da aceleradora",
          description:
            "Com a associação e a aceleradora selecionada, inicie o processo formal de candidatura ao projeto de transição digital.",
        },
        {
          title: "3 · Realize o diagnóstico de maturidade digital do seu negócio",
          description:
            "O diagnóstico será feito para avaliar o nível de digitalização da sua empresa e identificar oportunidades de melhoria.",
        },
        {
          title: "4 · Receba um plano estratégico com atividades-chave para o projeto",
          description:
            "Com base no diagnóstico, será elaborado um plano estratégico personalizado com as atividades necessárias para transformar digitalmente o seu negócio.",
        },
        {
          title: "5 · Receba o voucher com o financiamento para executar o projeto",
          description:
            "Após a aprovação, receberá um voucher com o financiamento necessário para implementar as medidas definidas.",
        },
        {
          title: "6 · Escolha os serviços adequados no Catálogo de Serviços",
          description:
            "Selecione os serviços que melhor se adaptam às necessidades do seu projeto de digitalização, com base no catálogo de serviços disponíveis.",
        },
      ],
    },
    faq: {
      title: "Perguntas frequentes",
      items: [
        {
          question: "O que é o Catálogo de Serviços de Transição Digital?",
          answer:
            "O Catálogo de Serviços de Transição Digital é uma iniciativa do PRR que oferece serviços de digitalização a PME, permitindo a modernização dos seus negócios através de soluções tecnológicas e inovadoras.",
        },
        {
          question: "Quem pode beneficiar deste apoio?",
          answer:
            "Micro, pequenas e médias empresas (PME) e Empresários em Nome Individual (ENI), dos setores de comércio e serviços, podem concorrer, desde que cumpram os critérios de elegibilidade.",
        },
        {
          question: "Que serviços estão disponíveis no catálogo?",
          answer:
            "Os serviços incluem criação de lojas online, gestão de clientes (CRM), marketing digital, otimização de websites, cibersegurança e integração com plataformas de vendas digitais.",
        },
        {
          question: "Quanto financiamento posso obter?",
          answer:
            "As empresas podem receber até 2.000€ de financiamento a fundo perdido para aquisição dos serviços digitais disponíveis no catálogo.",
        },
        {
          question: "Como posso candidatar-me?",
          answer:
            "A candidatura é feita através das associações comerciais da região da empresa. A associação realizará um diagnóstico de maturidade digital e irá orientá-lo no processo de submissão.",
        },
        {
          question: "O que acontece após a candidatura?",
          answer:
            "Após a submissão, a candidatura será avaliada e, uma vez aprovada, a empresa pode começar a implementar os serviços selecionados, com o acompanhamento dos fornecedores acreditados.",
        },
        {
          question: "Quanto tempo demora a candidatura a ser aprovada?",
          answer:
            "O tempo de aprovação pode variar, mas geralmente há uma fase de avaliação após a submissão. As empresas são notificadas assim que a candidatura é aprovada. O acompanhamento é feito pela associação comercial e empresarial.",
        },
        {
          question: "Posso escolher mais de um pacote de serviços?",
          answer:
            "Sim. As empresas podem escolher um ou mais pacotes de serviços, desde que o valor total não exceda os 2.000€. Por exemplo, pode optar por um pacote de 500€ e outro de 1.500€, totalizando 2.000€. Não é obrigatório perfazer o valor máximo, pelo que também pode escolher um único pacote.",
        },
      ],
    },
  },

  en: {
    hero: {
      title: "Digital Transition Services",
      body:
        "Invisible Cloud is an accredited provider in the Digital Transition Services catalogue. We deliver cloud solutions and complete digital experiences to accelerate the modernization of your business.",
      button: "I want to apply",
    },

    overviewHighlights: [
      {
        title: "Funding up to €2,000",
        description:
          "Receive up to €2,000 to adopt services that digitise and increase your company’s competitiveness.",
      },
      {
        title: "100% non-repayable",
        description:
          "Services are funded at 100%, fully covering eligible expenses at no cost to your company.",
      },
      {
        title: "Grow in the digital market",
        description:
          "Secure your online presence with services that boost brand visibility and attract more customers.",
      },
      {
        title: "Accredited providers",
        description:
          "Work with accredited companies like Invisible Cloud to ensure you receive the best digital solutions.",
      },
    ],
    overview: {
      title: "What is the Digital Transition Services Catalogue?",
      description:
        "The Digital Transition Services Catalogue is a PRR initiative that offers SMEs and sole traders access to specialised services to accelerate their digital transformation. The catalogue brings together accredited providers, such as Invisible Cloud, offering solutions to digitise your business and enhance your online presence. With non-repayable support up to €2,000, you can choose from a range of services, from launching an online store to digital marketing and CRM tools. The goal is to help SMEs compete more effectively in the digital market with the necessary technical and financial support.",
    },
    eligibility: {
      title: "Is your company eligible?",
      intro:
        "If you are an SME or a sole trader seeking support to create or improve your digital strategy and presence, the Digital Transition Services may be ideal. This programme offers non-repayable support up to €2,000, allowing you to digitise your business with no additional cost.",
      highlights: [
        {
          title: "SME or Sole Trader",
          description: "Micro, small and medium enterprises operating in Portugal.",
        },
        {
          title: "Eligible sectors",
          description:
            "Primary CAE covered by the programme and regular operations within Portuguese territory.",
        },
        {
          title: "Fiscal compliance",
          description:
            "Tax and social security status in good standing with the authorities.",
        },
      ],
    },
    steps: {
      title: "How to apply?",
      note:
        "The accredited provider is chosen by the applicant. Select a partner that understands your growth objectives.",
      items: [
        {
          title: "1 · Contact the business association in your region",
          description:
            "Local business associations are the starting point. They guide the application process and ensure you apply to the appropriate digital commerce accelerators.",
        },
        {
          title: "2 · Start the application process with the accelerator",
          description:
            "With the association and chosen accelerator, begin the formal application for the digital transition project.",
        },
        {
          title: "3 · Complete your company’s digital maturity assessment",
          description:
            "The assessment determines your current level of digitisation and identifies improvement opportunities.",
        },
        {
          title: "4 · Receive a strategic plan with key project activities",
          description:
            "Based on the assessment, a tailored strategic plan is prepared with the activities required to transform your business.",
        },
        {
          title: "5 · Receive the voucher to execute the project",
          description:
            "Once approved, you will receive a voucher with the funds needed to implement the planned measures.",
        },
        {
          title: "6 · Choose the appropriate services in the Catalogue",
          description:
            "Select the services that best fit your digitisation needs from the available catalogue.",
        },
      ],
    },
    faq: {
      title: "Frequently asked questions",
      items: [
        {
          question: "What is the Digital Transition Services Catalogue?",
          answer:
            "It is a PRR initiative offering digitisation services to SMEs, enabling business modernization through innovative technology solutions.",
        },
        {
          question: "Who can benefit from this support?",
          answer:
            "Micro, small and medium enterprises (SMEs) and sole traders in commerce and services may apply, provided they meet the eligibility criteria.",
        },
        {
          question: "Which services are available in the catalogue?",
          answer:
            "Services include online store creation, customer relationship management (CRM), digital marketing, website optimisation, cybersecurity and integrations with digital sales platforms.",
        },
        {
          question: "How much funding can I obtain?",
          answer:
            "Companies can receive up to €2,000 in non-repayable funding to acquire services available in the catalogue.",
        },
        {
          question: "How do I apply?",
          answer:
            "Applications are submitted via your regional business association. They will conduct a digital maturity assessment and guide you through submission.",
        },
        {
          question: "What happens after applying?",
          answer:
            "After submission, the application is evaluated and, once approved, the company can start implementing the selected services with accredited providers’ support.",
        },
        {
          question: "How long does approval take?",
          answer:
            "Timelines vary, but typically there is an evaluation phase after submission. Businesses are notified upon approval, with follow-up coordinated by the association.",
        },
        {
          question: "Can I choose more than one service bundle?",
          answer:
            "Yes. You may select one or more bundles as long as the total does not exceed €2,000. For instance, a €500 package plus a €1,500 package. Reaching the maximum is not mandatory.",
        },
      ],
    },
  },
};

const packagesContent = {
  pt: {
    groups: [
      {
        title: "Pacotes Invisible Link",
        carousel: true,
        items: [
          {
            price: "500€",
            name: "LINK",
            category: "Marketing Digital",
            description:
              "Criação e definição de processo para envio de 20.000 comunicações email/SMS para Portugal.",
            image: "/assets/pacotes/1.1.png",
            ctaUrl: "https://portal.invisiblecloud.pt/new/",
            ctaLabel: { pt: "Abrir Conta", en: "Open Account" },
          },
          {
            price: "1000€",
            name: "LINK",
            category: "Marketing Digital",
            description:
              "Criação e definição de processo para envio de 50.000 comunicações email/SMS para Portugal.",
            image: "/assets/pacotes/1.2.png",
            ctaUrl: "https://portal.invisiblecloud.pt/new/",
            ctaLabel: { pt: "Abrir Conta", en: "Open Account" },
          },
          {
            price: "1500€",
            name: "LINK",
            category: "Marketing Digital",
            description:
              "Criação e definição de processo para envio de 80.000 comunicações email/SMS para Portugal.",
            image: "/assets/pacotes/1.3.png",
            ctaUrl: "https://portal.invisiblecloud.pt/new/",
            ctaLabel: { pt: "Abrir Conta", en: "Open Account" },
          },

          {
            price: "2000€",
            name: "LINK",
            category: "Marketing Digital",
            description:
              "Criação e definição de processo para envio de 125.000 comunicações email/SMS para Portugal.",
            image: "/assets/pacotes/1.4.png",
            ctaUrl: "https://portal.invisiblecloud.pt/new/",
            ctaLabel: { pt: "Abrir Conta", en: "Open Account" },
          },
          {
            price: "500€",
            name: "LINK",
            category: "Serviços de Alojamento",
            description:
              "Criação, Desenvolvimento e Alojamento de landing page em HTML em dominio do cliente.",
            image: "/assets/pacotes/2.1.png",
            ctaUrl: "mailto:info@invisiblecloud.pt",
            ctaLabel: { pt: "Contactar", en: "Contact" },
          },
          {
            price: "1000€",
            name: "LINK",
            category: "Serviços de Alojamento",
            description:
              "Criação, Desenvolvimento e Alojamento de website em HTML, com setup de 5 caixa de email de 1GB cada e dominio incluido.",
            image: "/assets/pacotes/2.2.png",
            ctaUrl: "mailto:info@invisiblecloud.pt",
            ctaLabel: { pt: "Contactar", en: "Contact" },
          },
          {
            price: "1500€",
            name: "LINK",
            category: "Serviços de Alojamento",
            description:
              "Website HTML com 5 caixas de email, domínio incluído e integração com pagamentos pré-configurados.",
            image: "/assets/pacotes/2.3.png",
            ctaUrl: "mailto:info@invisiblecloud.pt",
            ctaLabel: { pt: "Contactar", en: "Contact" },
          },
          {
            price: "2000€",
            name: "LINK",
            category: "Serviços de Alojamento",
            description:
              "Criação, desenvolvimento e alojamento de website em HTML, com setup de 5 caixas de email de 1GB cada, domínio incluído, ligação a fornecedores de pagamentos pré-integrados e campanha de divulgação para 20.000 contactos.",
            image: "/assets/pacotes/2.3.png",
            ctaUrl: "mailto:info@invisiblecloud.pt",
            ctaLabel: { pt: "Contactar", en: "Contact" },
          },
        ],
      },
      {
        title: "Pacotes Invisible Collector",
        gridClass: "md:grid-cols-2 lg:grid-cols-4",
        accentColor: "#E83B3C",
        items: [
          {
            price: "500€",
            name: "COLLECTOR",
            category: "Gestão e Relacionamento de Clientes",
            description:
              "Licença Invisible Collector com setup de conta, onboarding de dados e 1 mês premium incluído.",
            image: "/assets/pacotes/3.1.png",
            ctaUrl: "https://invisiblecollector.com/#pricing",
            ctaLabel: { pt: "Ver mais", en: "See more" },
          },
          {
            price: "1000€",
            name: "COLLECTOR",
            category: "Gestão e Relacionamento de Clientes",
            description:
              "Licença Invisible Collector com setup de conta, onboarding de dados e 2 meses premium incluídos.",
            image: "/assets/pacotes/3.2.png",
            ctaUrl: "https://invisiblecollector.com/#pricing",
            ctaLabel: { pt: "Ver mais", en: "See more" },
          },
          {
            price: "1500€",
            name: "COLLECTOR",
            category: "Gestão e Relacionamento de Clientes",
            description:
              "Licença Invisible Collector com setup de conta, onboarding de dados e 3 meses premium incluídos.",
            image: "/assets/pacotes/3.3.png",
            ctaUrl: "https://invisiblecollector.com/#pricing",
            ctaLabel: { pt: "Ver mais", en: "See more" },
          },
          {
            price: "2000€",
            name: "COLLECTOR",
            category: "Gestão e Relacionamento de Clientes",
            description:
              "Licença Invisible Collector com setup de conta, onboarding de dados e 4 meses premium, incluindo suporte avançado.",
            image: "/assets/pacotes/3.4.png",
            ctaUrl: "https://invisiblecollector.com/#pricing",
            ctaLabel: { pt: "Ver mais", en: "See more" },
          },
        ],
      },
    ],
  },
  en: {
    groups: [
      {
        title: "Invisible Link Packages",
        carousel: true,
        items: [
          {
            price: "€500",
            name: "LINK",
            category: "Digital Marketing",
            description:
              "Process design and delivery for 20,000 email/SMS communications across Portugal.",
            image: "/assets/pacotes/1.1.png",
            ctaUrl: "https://portal.invisiblecloud.pt/new/",
            ctaLabel: { pt: "Abrir Conta", en: "Open Account" },
          },
          {
            price: "€1,000",
            name: "LINK",
            category: "Digital Marketing",
            description:
              "Process design and delivery for 50,000 email/SMS communications across Portugal.",
            image: "/assets/pacotes/1.2.png",
            ctaUrl: "https://portal.invisiblecloud.pt/new/",
            ctaLabel: { pt: "Abrir Conta", en: "Open Account" },
          },
          {
            price: "€1,500",
            name: "LINK",
            category: "Digital Marketing",
            description:
              "Process design and delivery for 80,000 email/SMS communications across Portugal.",
            image: "/assets/pacotes/1.3.png",
            ctaUrl: "https://portal.invisiblecloud.pt/new/",
            ctaLabel: { pt: "Abrir Conta", en: "Open Account" },
          },
          {
            price: "€2,000",
            name: "LINK",
            category: "Digital Marketing",
            description:
              "Process design and delivery for 125,000 email/SMS communications across Portugal.",
            image: "/assets/pacotes/1.3.png",
            ctaUrl: "https://portal.invisiblecloud.pt/new/",
            ctaLabel: { pt: "Abrir Conta", en: "Open Account" },
          },
          {
            price: "€500",
            name: "LINK",
            category: "Hosting Services",
            description:
              "Landing page creation, development and hosting (HTML) using the client's domain.",
            image: "/assets/pacotes/2.1.png",
            ctaUrl: "mailto:info@invisiblecloud.pt",
            ctaLabel: { pt: "Contactar", en: "Contact" },
          },
          {
            price: "€1,000",
            name: "LINK",
            category: "Hosting Services",
            description:
              "Creation, development and hosting of a website in HTML, with the setup of 5 email inboxes of 1GB each and domain included.",
            image: "/assets/pacotes/2.2.png",
            ctaUrl: "mailto:info@invisiblecloud.pt",
            ctaLabel: { pt: "Contactar", en: "Contact" },
          },
          {
            price: "€1,500",
            name: "LINK",
            category: "Hosting Services",
            description:
              "HTML website with 5 email inboxes, domain included, and integration with pre-configured payments.",
            image: "/assets/pacotes/2.3.png",
            ctaUrl: "mailto:info@invisiblecloud.pt",
            ctaLabel: { pt: "Contactar", en: "Contact" },
          },
          {
            price: "€2,000",
            name: "LINK",
            category: "Hosting Services",
            description:
              "HTML website creation, development and hosting with 5x 1 GB email inboxes, domain included, pre-integrated payment provider connections and an outreach campaign for 20,000 contacts.",
            image: "/assets/pacotes/2.3.png",
            ctaUrl: "mailto:info@invisiblecloud.pt",
            ctaLabel: { pt: "Contactar", en: "Contact" },
          },
        ],
      },
      {
        title: "Invisible Collector Packages",
        gridClass: "md:grid-cols-2 lg:grid-cols-4",
        accentColor: "#E83B3C",
        items: [
          {
            price: "€500",
            name: "COLLECTOR",
            category: "Customer Relationship Management",
            description:
              "Invisible Collector license with account setup, data onboarding and 1 month of premium access included.",
            image: "/assets/pacotes/3.1.png",
            ctaUrl: "https://invisiblecollector.com/#pricing",
            ctaLabel: { pt: "Ver mais", en: "See more" },
          },
          {
            price: "€1,000",
            name: "COLLECTOR",
            category: "Customer Relationship Management",
            description:
              "Invisible Collector license with account setup, data onboarding and 2 months of premium access included.",
            image: "/assets/pacotes/3.2.png",
            ctaUrl: "https://invisiblecollector.com/#pricing",
            ctaLabel: { pt: "Ver mais", en: "See more" },
          },
          {
            price: "€1,500",
            name: "COLLECTOR",
            category: "Customer Relationship Management",
            description:
              "Invisible Collector license with account setup, data onboarding and 3 months of premium access included.",
            image: "/assets/pacotes/3.3.png",
            ctaUrl: "https://invisiblecollector.com/#pricing",
            ctaLabel: { pt: "Ver mais", en: "See more" },
          },
          {
            price: "€2,000",
            name: "COLLECTOR",
            category: "Customer Relationship Management",
            description:
              "Invisible Collector license with account setup, data onboarding and 3 months of premium access plus advanced support.",
            image: "/assets/pacotes/3.4.png",
            ctaUrl: "https://invisiblecollector.com/#pricing",
            ctaLabel: { pt: "Ver mais", en: "See more" },
          },
        ],
      },
    ],
  },
};

function chunkItems(items, size) {
  const result = [];
  for (let i = 0; i < items.length; i += size) {
    result.push(items.slice(i, i + size));
  }
  return result;
}

function PackageCard({
  price,
  name,
  category,
  description,
  image,
  ctaUrl,
  ctaLabel,
  lang,
  accentColor = "#1F8483",
  revealDelayClass = "",
}) {
  const label =
    (ctaLabel && (typeof ctaLabel === "string" ? ctaLabel : ctaLabel[lang] || ctaLabel.pt || ctaLabel.en)) ||
    (lang === "pt" ? "Saber mais" : "Learn more");
  const isMailTo = typeof ctaUrl === "string" && ctaUrl.startsWith("mailto:");
  const defaultHoverBg = accentColor === "#1F8483" ? "#E7F6F3" : "#FDE0E0";
  return (
    <article
      className={`group flex h-full flex-col overflow-hidden rounded-[32px] border border-[#D5ECE6] bg-white shadow-[0_40px_70px_-60px_rgba(12,66,61,0.55)] transition-all duration-300 hover:-translate-y-[8px] hover:border-[#B9E4DC] hover:shadow-[0_48px_90px_-55px_rgba(12,66,61,0.65)] reveal ${revealDelayClass}`}
      data-reveal="zoom"
    >
      <div
        className="flex items-center justify-between px-6 py-3 text-xs font-semibold uppercase tracking-[0.3em]"
        style={{ backgroundColor: accentColor === "#1F8483" ? "#EAF6F3" : "#FCE9EA", color: accentColor }}
      >
        <span>{name}</span>
        <span className="rounded-full bg-white px-3 py-1 text-[11px] text-[#0D2D2A]">{price}</span>
      </div>
      <div className="overflow-hidden">
        {image ? (
          <img
            src={image}
            alt={`${category}`}
            className="w-full object-cover transition duration-300 group-hover:scale-[1.02]"
          />
        ) : (
          <div
            className="flex h-48 w-full items-center justify-center text-xs font-medium uppercase tracking-[0.3em]"
            style={{
              background:
                accentColor === "#1F8483"
                  ? "radial-gradient(circle at top, #E4F4F0, transparent 65%)"
                  : "radial-gradient(circle at top, #FAD2D3, transparent 65%)",
              color: accentColor,
            }}
          >
            Invisible Cloud
          </div>
        )}
      </div>
      <div className="flex flex-1 flex-col gap-4 px-6 py-6">
        <span
          className="inline-flex w-fit items-center rounded-full px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.28em]"
          style={{ backgroundColor: accentColor === "#1F8483" ? "#F0FAF7" : "#FDE7E7", color: accentColor }}
        >
          {category}
        </span>
        <p className="text-sm leading-6 text-[#2F3B3A]">{description}</p>
        {ctaUrl && (
          <a
            href={ctaUrl}
            target={isMailTo ? undefined : "_blank"}
            rel={isMailTo ? undefined : "noopener noreferrer"}
            className="mt-auto inline-flex w-fit items-center gap-2 rounded-full px-4 py-2 text-xs font-semibold uppercase tracking-[0.3em] transition"
            style={{ border: `1px solid ${accentColor}`, color: accentColor }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = defaultHoverBg)}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
          >
            {label}
            <span className="text-[14px]">→</span>
          </a>
        )}
      </div>
    </article>
  );
}

export default function PRR({ lang = "pt", onLanguageChange }) {
  const content = copy[lang] || copy.pt;
  const packages = packagesContent[lang] || packagesContent.pt;
  const [openFaq, setOpenFaq] = useState(null);
  const [linkSlide, setLinkSlide] = useState(0);

  useEffect(() => {
    setLinkSlide(0);
  }, [lang]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -5% 0px",
      }
    );

    const reveals = document.querySelectorAll(".reveal");
    reveals.forEach((el) => {
      if (!el.classList.contains("reveal-visible")) {
        observer.observe(el);
      }
    });

    return () => observer.disconnect();
  }, [lang, linkSlide]);

  return (
    <>
      <Navbar activeLang={lang} onLanguageChange={onLanguageChange} />
      <main className="bg-[#F6FBFA] overflow-x-hidden">
        <section className="relative overflow-hidden bg-white">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(76,177,161,0.18),transparent_55%)]" />
          <div
            className="
              relative mx-auto flex w-full max-w-6xl flex-col items-center justify-center gap-8
              px-4 py-12 text-center sm:px-6 md:py-16
              min-h-[68svh] sm:min-h-[64svh] md:min-h-[58svh] xl:min-h-screen
              translate-y-0 xl:-translate-y-[7vh]
              lg:px-0
            "
          >
            <div
              className="w-full max-w-[90vw] sm:max-w-2xl space-y-7 px-2 text-center text-[#0D2D2A] reveal !translate-x-0 mx-auto flex flex-col items-center sm:px-4 xl:mx-0 xl:max-w-[55%] xl:items-start xl:text-left xl:space-y-8"
              data-reveal="fade-right"
            >
              {content.hero.badge && (
                <span className="inline-flex items-center rounded-full bg-[#E4F4F0] px-4 py-1 text-sm font-semibold tracking-[0.18em] uppercase text-[#1F8483]">
                  {content.hero.badge}
                </span>
              )}
              <h1 className="text-3xl font-bold leading-[1.15] tracking-[-0.01em] sm:text-4xl lg:text-[46px]">
                {content.hero.title}
              </h1>
              <p className="mx-auto text-lg leading-relaxed text-[#2F3B3A] lg:mx-0 lg:max-w-xl">{content.hero.body}</p>
              <div className="flex w-full flex-wrap justify-center gap-4 lg:justify-start">
                {content.hero.button && (
                  <a
                    href="#steps"
                    className="rounded-full bg-[#4CB1A1] px-6 py-3 text-sm font-semibold uppercase tracking-[0.22em] text-white shadow-lg shadow-[#4CB1A1]/35 transition hover:bg-[#2B8D80]"
                  >
                    {content.hero.button}
                  </a>
                )}
                {content.hero.secondary && (
                  <a
                    href="#ppr-faq"
                    className="rounded-full border border-[#4CB1A1] px-6 py-3 text-sm font-semibold uppercase tracking-[0.22em] text-[#1F8483] transition hover:bg-[#E7F6F3]"
                  >
                    {content.hero.secondary}
                  </a>
                )}
              </div>
            </div>
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
              <button
                type="button"
                onClick={() => document.getElementById("ppr-overview")?.scrollIntoView({ behavior: "smooth" })}
                className="mt-14 hidden flex-col items-center rounded-full bg-white/90 px-3 py-4 text-[#1F8483] shadow-[0_16px_40px_-30px_rgba(12,66,61,0.6)] transition hover:bg-white md:flex"
                aria-label={lang === "pt" ? "Rolar para ver mais" : "Scroll to explore"}
              >
                <span className="text-xs font-semibold uppercase tracking-[0.32em] text-[#1F8483]">
                  {lang === "pt" ? "Explorar" : "Explore"}
                </span>
                <svg className="mt-3 h-6 w-6 scroll-indicator" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M10 2a.75.75 0 0 1 .75.75v12.19l2.72-2.72a.75.75 0 0 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2.75A.75.75 0 0 1 10 2Z" />
                </svg>
              </button>
            </div>
          </div>
        </section>

        <section id="ppr-overview" className="relative bg-white">
          <div className="pointer-events-none absolute inset-x-0 top-10 hidden h-[420px] rounded-[48px] bg-[radial-gradient(circle_at_center,rgba(76,177,161,0.16),rgba(76,177,161,0)_70%)] blur-xl md:block" />
          <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center gap-10 px-4 py-16 text-center sm:px-6 xl:flex-row xl:items-start xl:justify-between xl:px-0 xl:text-left">
            <div className="relative w-full max-w-[90vw] sm:max-w-2xl px-2 sm:px-4 reveal !translate-x-0 text-center mx-auto flex flex-col items-center xl:mx-0 xl:max-w-[58%] xl:items-start xl:text-left" data-reveal="fade-right">
              <span className="inline-flex items-center gap-2 rounded-full border border-[#BFE7DD] bg-[#EFFBF8] px-4 py-2 text-xs font-semibold uppercase tracking-[0.4em] text-[#1F8483]">
                {lang === "pt" ? "Programa PRR" : "PRR programme"}
              </span>
              <h2 className="mt-6 text-[32px] font-semibold leading-tight text-[#0D2D2A] sm:text-[36px]">
                {content.overview.title}
              </h2>
              <p className="mt-6 text-lg leading-7 text-[#2F3B3A]">{content.overview.description}</p>
              <a
                href="https://digital.gov.pt/estrategias/plano-de-acao-para-a-transicao-digital/portugal-digital"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-[#1F8483] px-6 py-3 text-sm font-semibold uppercase tracking-[0.24em] text-white shadow-[0_22px_44px_-30px_rgba(12,66,61,0.6)] transition hover:bg-[#176865]"
              >
                {lang === "pt" ? "Saber mais" : "Learn more"}
                <span aria-hidden="true" className="text-base">
                  →
                </span>
              </a>
            </div>
            <div className="relative flex w-full max-w-[90vw] sm:max-w-2xl flex-1 flex-col items-center gap-4 text-center reveal !translate-x-0 px-2 sm:px-4 mx-auto xl:mx-0 xl:max-w-none xl:items-stretch xl:text-left xl:pl-12 2xl:pl-16" data-reveal="fade-left">
              <div className="relative overflow-hidden rounded-[28px] border border-[#D5ECE6] bg-white/95 p-6 shadow-[0_32px_70px_-60px_rgba(12,66,61,0.55)] lg:p-8">
                <div className="pointer-events-none absolute -top-16 -left-12 hidden h-[260px] w-[260px] rounded-full bg-[radial-gradient(circle,rgba(76,177,161,0.2)_0%,rgba(76,177,161,0)_75%)] md:block" />
                <div className="pointer-events-none absolute -bottom-20 right-[-60px] hidden h-[280px] w-[180px] rotate-12 bg-[linear-gradient(158deg,rgba(31,132,131,0.12)_0%,rgba(255,255,255,0)_70%)] md:block" />
                <div className="relative">
                  <ul className="space-y-4">
                    {(content.overviewHighlights || []).map((item, index) => {
                      const delayClass = index === 0 ? "" : `reveal-delay-${Math.min(index * 100, 400)}`;
                      return (
                        <li
                          key={item.title}
                          className={`flex items-start gap-4 rounded-[20px] bg-white/95 p-5 text-sm leading-6 text-[#213B39] shadow-[0_22px_60px_-48px_rgba(12,66,61,0.55)] ring-1 ring-[#DCEFE9] transition-all duration-300 hover:-translate-y-[4px] hover:ring-[#B8E4DC] hover:shadow-[0_32px_78px_-52px_rgba(12,66,61,0.6)] reveal ${delayClass}`}
                        >
                          <span className="mt-1 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#E6F6F2] text-sm font-semibold text-[#1F8483]">
                            {String(index + 1).padStart(2, "0")}
                          </span>
                          <span>
                            <span className="block text-sm font-semibold text-[#0D2D2A]">{item.title}</span>
                            <span className="mt-1 block text-sm text-[#2F3B3A]">{item.description}</span>
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="relative bg-[#F6FBFA]">
          <div className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-[rgba(31,132,131,0.08)] to-transparent" />
          <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 lg:px-0">
            <div className="space-y-16">
              {packages.groups.map((group) => {
                const accentColor = group.accentColor || "#1F8483";


                if (group.carousel) {
                  const slides = chunkItems(group.items, 4);
                  const activeSlide = Math.min(linkSlide, slides.length - 1);

                  return (
                    <div key={group.title} className="space-y-6">
                      <div className="flex flex-col gap-2 text-left">
                        <h3 className="text-[28px] font-semibold text-[#0D2D2A]">{group.title}</h3>
                      </div>
                      <div className="relative">
                        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
                          {slides[activeSlide].map((item, cardIndex) => (
                            <PackageCard
                              key={`${group.title}-${item.name}-${cardIndex}`}
                              {...item}
                              lang={lang}
                              accentColor={accentColor}
                              revealDelayClass={
                                cardIndex === 0 ? "" : `reveal-delay-${Math.min(cardIndex * 100, 400)}`
                              }
                            />
                          ))}
                        </div>
                        <button
                          type="button"
                          onClick={() => setLinkSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1))}
                          className="absolute left-[-1.75rem] top-1/2 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-lg shadow-sm transition"
                          style={{ border: `1px solid ${accentColor}`, color: accentColor }}
                          aria-label={lang === "pt" ? "Pacote anterior" : "Previous slide"}
                          onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            accentColor === "#1F8483" ? "#E7F6F3" : "#FDE0E0")
                          }
                          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
                        >
                          ‹
                        </button>
                        <button
                          type="button"
                          onClick={() => setLinkSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1))}
                          className="absolute right-[-1.75rem] top-1/2 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-lg shadow-sm transition"
                          style={{ border: `1px solid ${accentColor}`, color: accentColor }}
                          aria-label={lang === "pt" ? "Próximo pacote" : "Next slide"}
                          onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            accentColor === "#1F8483" ? "#E7F6F3" : "#FDE0E0")
                          }
                          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
                        >
                          ›
                        </button>
                        <div className="mt-6 flex items-center justify-center gap-3">
                          {slides.map((_, idx) => (
                            <button
                              key={`${group.title}-indicator-${idx}`}
                              type="button"
                              onClick={() => setLinkSlide(idx)}
                              className="h-2.5 w-7 rounded-full transition"
                              style={{
                                backgroundColor:
                                  idx === activeSlide
                                    ? accentColor
                                    : accentColor === "#1F8483"
                                      ? "#C7E6DF"
                                      : "#F7B8B9",
                              }}
                              aria-label={`Slide ${idx + 1}`}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  );
                }

                return (
                  <div key={group.title}>
                    <div className="flex flex-col gap-3 text-left">
                      <h3 className="text-[28px] font-semibold text-[#0D2D2A]">{group.title}</h3>

                    </div>
                    <div className={`mt-6 grid gap-8 ${group.gridClass || "md:grid-cols-2 lg:grid-cols-3"}`}>
                      {group.items.map((item, idx) => (
                        <PackageCard
                          key={`${group.title}-${item.name}-${idx}`}
                          {...item}
                          lang={lang}
                          accentColor={accentColor}
                          revealDelayClass={idx === 0 ? "" : `reveal-delay-${Math.min(idx * 100, 400)}`}
                        />
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="bg-white">
          <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 lg:px-0">
            <div className="grid gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:items-start">
              <div>
                <h2 className="text-[32px] font-semibold text-[#0D2D2A]">{content.eligibility.title}</h2>
                <p className="mt-6 text-lg leading-7 text-[#2F3B3A]">{content.eligibility.intro}</p>
              </div>
              <div className="space-y-5">
                {content.eligibility.highlights.map((item) => (
                  <div
                    key={item.title}
                    className="group grid grid-cols-[auto_1fr] items-start gap-4 rounded-[24px] border border-[#DCEFE9] bg-white px-6 py-5 shadow-[0_20px_45px_-40px_rgba(17,66,61,0.6)] transition-all duration-300 hover:-translate-y-[4px] hover:border-[#B8E6DC] hover:shadow-[0_28px_60px_-48px_rgba(17,66,61,0.55)]"
                  >
                    <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded border border-[#C2E3DD] text-[#C2E3DD] transition group-hover:border-[#1F8483] group-hover:text-[#1F8483] group-hover:bg-[#E7F6F3]">
                      <svg
                        viewBox="0 0 16 16"
                        className="h-3.5 w-3.5 transition-all duration-300 ease-out [stroke-dasharray:16] [stroke-dashoffset:16] group-hover:[stroke-dashoffset:0]"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M4.2 8.4 6.6 10.8 11.6 5.8" />
                      </svg>
                    </span>
                    <div>
                      <h3 className="text-base font-semibold text-[#0D2D2A]">{item.title}</h3>
                      <p className="mt-2 text-sm text-[#2F3B3A]">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section id="steps" className="mx-auto max-w-6xl px-4 py-16 md:px-6 lg:px-0">
          <div>
            <h2 className="text-[32px] font-semibold text-[#0D2D2A]">{content.steps.title}</h2>
            <div className="mt-6 space-y-4">
              {content.steps.items.map((item) => (
                <div
                  key={item.title}
                  className="rounded-[28px] border border-[#D5ECE6] bg-white px-6 py-6 shadow-[0_32px_60px_-55px_rgba(12,66,61,0.5)] transition-all duration-300 hover:-translate-y-[4px] hover:border-[#B8E4DC] hover:shadow-[0_34px_70px_-50px_rgba(12,66,61,0.55)]"
                >
                  <p className="text-base font-semibold text-[#0D2D2A]">{item.title}</p>
                  <p className="mt-2 text-sm text-[#2F3B3A]">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="ppr-faq" className="bg-white">
          <div className="mx-auto max-w-6xl px-4 py-20 md:px-6 lg:px-0">
            <div className="text-left">
              <h2 className="text-[32px] font-semibold text-[#0D2D2A]">{content.faq.title}</h2>
              {content.faq.subtitle && (
                <p className="mt-3 text-sm uppercase tracking-[0.3em] text-[#1F8483]">{content.faq.subtitle}</p>
              )}
            </div>
            <div className="mt-10 space-y-4">
              {content.faq.items.map((item, index) => {
                const expanded = openFaq === index;
                return (
                  <div
                    key={item.question}
                    className={`rounded-[24px] border shadow-[0_24px_50px_-46px_rgba(12,66,61,0.55)] transition-all duration-300 ${expanded
                      ? "border-[#D5ECE6] bg-white"
                      : "border-[#E4F4F0] bg-[#F6FBFA] hover:-translate-y-[3px] hover:border-[#CBE8E3] hover:shadow-[0_28px_58px_-48px_rgba(12,66,61,0.55)]"
                      }`}
                  >
                    <button
                      type="button"
                      aria-expanded={expanded}
                      onClick={() => setOpenFaq(expanded ? null : index)}
                      className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                    >
                      <span className="text-base font-semibold text-[#0D2D2A]">{item.question}</span>
                      <span
                        className={`inline-flex h-8 w-8 items-center justify-center rounded-full border border-[#4CB1A1] text-[#1F8483] transition-transform ${expanded ? "rotate-45" : ""
                          }`}
                      >
                        +
                      </span>
                    </button>
                    {expanded && <div className="px-6 pb-6 text-sm leading-6 text-[#2F3B3A]">{item.answer}</div>}
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="bg-[#F0FAF8]">
          <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 lg:px-0">
            <div className="reveal" data-reveal="fade-up">
              <h2 className="text-[28px] font-semibold text-[#0D2D2A]">
                {lang === "pt" ? "Apoios e Referências" : "Useful links"}
              </h2>

              <div className="mt-8 grid gap-3 text-sm font-semibold text-[#0D2D2A] md:grid-cols-3">
                {[
                  {
                    href: "http://link.invisiblecloud.pt",
                    label: lang === "pt" ? "Invisible Link" : "Invisible Cloud customer portal",
                  },
                  {
                    href: "https://invisiblecollector.com",
                    label: "Invisible Collector",
                  },
                  {
                    href:
                      "https://digital.gov.pt/estrategias/plano-de-acao-para-a-transicao-digital/portugal-digital",
                    label: lang === "pt" ? "Portugal Digital" : "Portugal Digital",
                  },
                ].map((link, index) => (
                  <a
                    key={link.href}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`group flex items-center justify-between rounded-[16px] border border-[#D5ECE6] bg-transparent px-5 py-4 text-[#1F2E2C] transition-all duration-200 hover:-translate-y-[2px] hover:border-[#1F8483] hover:bg-white/60 reveal ${index ? `reveal-delay-${Math.min(index * 100, 400)}` : ""
                      }`}
                  >
                    <span>{link.label}</span>
                    <span aria-hidden="true" className="text-base text-[#1F8483] transition-transform group-hover:translate-x-1">
                      →
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer lang={lang} />
    </>
  );
}
